var presentsWereChanged = true,
    presentsInitialized = false;

$(function () {
    $(document).on('shown.bs.modal', '#present-modal', function () {
        var $form = $('#presentForm');

        if ($form.length > 0 && !presentsInitialized) {
            $('body').on('click', '#present-modal .js-presents-modal-submit', function (event) {
                event.preventDefault();

                $(this).addClass('is-loading');

                if (presentsWereChanged) {
                    var url = $(this).attr('href');

                    Form.ajaxPost($form, function (data) {
                        window.location = url;
                    }, "json");
                } else {
                    $('#present-modal').modal('hide');
                }
            });

            presentsInitialized = true;
        }

        window.checkPresentsQuantities();
    })
});

window.checkPresentsQuantities = () => {
    $('#present-modal').find('.c-presents__list').each(function () {
        const $list = $(this),
            maxCount = $list.attr('data-max');

        let checkedCount = 0;

        $list.find('.js-present-quantity').each(function() {
            checkedCount += parseInt($(this).val());
        });

        $list.find('.js-present-quantity').each(function () {
            var maxValue = maxCount - checkedCount,
                maxStock = $(this).attr('data-stock'),
                actualValue = $(this).val();

            var newValue = parseInt(actualValue) + parseInt(maxValue);

            if (newValue > parseInt(maxStock)) {
                newValue = maxStock;
            }

            $(this).attr('max', newValue)

            if (newValue == 0) {
                $(this).parent().addClass('is-disabled');
            } else {
                $(this).parent().removeClass('is-disabled');
            }
        });
    });
};